// Route guards for the Order Ahead section, built on the rules in ./access.
//
// Kept apart from access.ts so the rules themselves import nothing and stay
// usable (and testable) without dragging in the user store or the router.
import {
  ActionFunction,
  ActionFunctionArgs,
  LoaderFunction,
  LoaderFunctionArgs,
  redirect,
} from "react-router-dom";
import { userStore } from "../../store/user";
import {
  canManageOrderAhead,
  canViewOrderAheadOrders,
  canViewOrderAheadSetup,
} from "./access";

const gate = (allowed: (user: any) => boolean) => async () => {
  const user = userStore.getState().user;
  if (!user) return redirect("/login");
  if (!allowed(user)) return redirect("/");
  return null;
};

export const orderAheadSetupGate = gate(canViewOrderAheadSetup);
export const orderAheadManageGate = gate(canManageOrderAhead);
export const orderAheadOrdersGate = gate(canViewOrderAheadOrders);

type Gate = () => Promise<Response | null>;

export const guardLoader =
  (check: Gate, loader?: LoaderFunction) => async (args: LoaderFunctionArgs) =>
    (await check()) ?? (loader ? await loader(args) : null);

// Loaders alone do not protect writes. A delete route carries only an `action`,
// and React Router runs actions without consulting any loader — so every write
// action needs wrapping too.
export const guardAction =
  (check: Gate, action: ActionFunction) => async (args: ActionFunctionArgs) =>
    (await check()) ?? (await action(args));
